import { render, staticRenderFns } from "./FinalSlide.vue?vue&type=template&id=51d9bb12&scoped=true&"
import script from "./FinalSlide.vue?vue&type=script&lang=js&"
export * from "./FinalSlide.vue?vue&type=script&lang=js&"
import style0 from "./FinalSlide.vue?vue&type=style&index=0&id=51d9bb12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d9bb12",
  null
  
)

export default component.exports